import React from 'react';
import { useLanguage } from '../lib/LanguageContext';

interface LogoProps {
  className?: string;
  variant?: 'square' | 'landscape' | 'icon' | 'white-on-transparent';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export default function Logo({ className = '', variant = 'landscape', size = 'md' }: LogoProps) {
  const { language, isRtl } = useLanguage();

  // Define size classes
  const sizeMap = {
    sm: variant === 'square' ? 'w-10 h-10 rounded-xl text-[7px]' : 'h-8',
    md: variant === 'square' ? 'w-24 h-24 rounded-2xl text-[14px]' : 'h-11',
    lg: variant === 'square' ? 'w-48 h-48 rounded-3xl text-[28px]' : 'h-14',
    xl: variant === 'square' ? 'w-64 h-64 rounded-[2.2rem]' : 'h-24',
  };

  const selectedSize = sizeMap[size];

  if (variant === 'square') {
    return (
      <img 
        id="logo-square-badge"
        src="/logo.png"
        alt="Sooq Mulak Logo"
        className={`object-contain shadow-xl shadow-brand-emerald/5 aspect-square ${selectedSize} ${className}`}
      />
    );
  }

  if (variant === 'icon') {
    return (
      <img 
        id="logo-icon-badge"
        src="/logo.png"
        alt="Sooq Mulak Logo"
        className={`object-contain rounded-xl shadow-md transition-transform duration-300 hover:scale-105 ${className}`}
        style={{ width: '46px', height: '46px' }}
      />
    );
  }

  if (variant === 'white-on-transparent') {
    return (
      <div id="logo-white-transparent" className={`flex items-center gap-3 select-none ${className}`}>
        {/* Emblem */}
        <img 
          src="/logo.png" 
          alt="Sooq Mulak Logo" 
          className="w-[46px] h-[46px] object-contain rounded-xl shadow-md transition-transform duration-300 hover:scale-105"
        />
      </div>
    );
  }

  // Landscape variant (perfect for Navbar / Header)
  return (
    <div id="logo-landscape-header" className={`flex items-center justify-center min-w-0 max-w-full select-none ${className}`}>
      {/* PNG Logo */}
      <img 
        src="/logo.png" 
        alt="Sooq Mulak Logo" 
        className="max-w-[200px] sm:max-w-[240px] md:max-w-[320px] lg:max-w-[400px] w-full h-auto object-contain transition-transform duration-300 hover:scale-105"
      />
    </div>
  );
}
